import { useState } from "react";
import { Building2 } from "lucide-react";
import { getOrganisationLogoUrl } from "../../utils/orgBranding";

/**
 * Renders organisation logo with fallback when the file is missing or the URL is wrong.
 */
export default function OrganisationLogo({
  logoUrl,
  cacheBust,
  alt = "Organisation logo",
  className = "",
  style,
}) {
  const [failed, setFailed] = useState(false);
  const src = getOrganisationLogoUrl(logoUrl, cacheBust);

  if (!src || failed) {
    return (
      <div
        className={`org-logo-fallback${className ? ` ${className}` : ""}`}
        style={style}
        aria-hidden
      >
        <Building2 size={22} strokeWidth={1.75} />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      onError={() => setFailed(true)}
    />
  );
}
